module.exports = __webpack_public_path__ + "static/media/OpenSans Regular-01.e3d96b41.svg";